import useDeepCompareEffect from 'use-deep-compare-effect';
import { reportViewEvent, ReportViewEventArgs } from './tracking';

/**
 * useDeepCompareEffect prevents this function to run every render.
 * It compares the args, when the args changed this gets called.
 * @param args
 */
export const useReportViewEvent = (args: ReportViewEventArgs): void => {
  useDeepCompareEffect(() => {
    reportViewEvent(args);
  }, [args]);
};
